module.exports = __webpack_public_path__ + "images/0dbcb3255ffaf7d6a796ea64fa6ad464a7361e96d681163a122e221935f7a9d1.svg";